import React, { useEffect, useState } from "react";
import {
    Box,
    Grid,
    TextField,
    Button,
    Typography,
} from "@mui/material";
import {
    makeGETRequestOnUserService,
    makePOSTRequestOnUserService,
} from "../../Api/api";

export const KartaDetails = ({ activeTab, currentUser, user_type, setValue, getErrorMessage }: any) => {
    const [form, setForm] = useState({
        name_of_karta: "",
        date_of_incorporation: "",
        occupation: "",
        huf_pan_card_plain_text_password: "",
        huf_deed_of_declaration_plain_text_password: "",
        karta_date_of_birth: "",
    });
    const toastr = require("toastr");
    const [panFile, setPanFile] = useState<File | null>(null);
    const [deedFile, setDeedFile] = useState<File | null>(null);

    const [panPreview, setPanPreview] = useState("");
    const [deedPreview, setDeedPreview] = useState("");

    const [loading, setLoading] = useState(false);
    const handleChange = (e: any) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };
    const handlePanUpload = (e: any) => {
        const file = e.target.files[0];
        if (file) {
            setPanFile(file);
            setPanPreview(URL.createObjectURL(file));
        }
    };
    const handleDeedUpload = (e: any) => {
        const file = e.target.files[0];
        if (file) {
            setDeedFile(file);
            setDeedPreview(URL.createObjectURL(file));
        }
    };
    const fetchKartaDetails = async () => {
        try {
            setLoading(true);

            const res = await makeGETRequestOnUserService(
                `/partneruser/huf_docs/download/${currentUser.uuid}/?user_type=${user_type}`
            );

            const data = res?.data || {};

            setForm({
                name_of_karta: data.name_of_karta || "",
                date_of_incorporation: data.date_of_incorporation || "",
                occupation: data.occupation || "",
                huf_pan_card_plain_text_password:
                    data.pan_card_plain_text_password || "",
                huf_deed_of_declaration_plain_text_password:
                    data.deed_of_declaration_plain_text_password || "",
                karta_date_of_birth: data.karta_date_of_birth || "",
            });

            if (data.pan_card_base64) {
                setPanPreview(`data:image/png;base64,${data.pan_card_base64}`);
            }

            if (data.deed_of_declaration_base64) {
                setDeedPreview(
                    `data:application/pdf;base64,${data.deed_of_declaration_base64}`
                );
            }
        } catch (err) {
            console.log("GET ERROR", err);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async () => {
        if (!panFile || !deedFile) {
            alert("Please upload both files");
            return;
        }
        try {
            setLoading(true);
            const formData = new FormData();
            formData.append("uuid", currentUser.uuid);
            formData.append("user_type", user_type);
            formData.append("pan_card", panFile);
            formData.append("deed_of_declaration", deedFile);
            formData.append("name_of_karta", form.name_of_karta);
            formData.append(
                "date_of_incorporation",
                form.date_of_incorporation
            );
            formData.append(
                "huf_pan_card_plain_text_password",
                form.huf_pan_card_plain_text_password
            );
            formData.append(
                "huf_deed_of_declaration_plain_text_password",
                form.huf_deed_of_declaration_plain_text_password
            );
            formData.append("occupation", form.occupation);
            formData.append("karta_date_of_birth", form.karta_date_of_birth);

            const resp = await makePOSTRequestOnUserService(
                `/partneruser/huf_docs/upload/?user_type=${user_type}`,
                formData
            );

            if (resp.status === 200 || resp.status === 201) {
                toastr.success("Karta Details Updated Successfully");
                fetchKartaDetails();
                setValue((prev: number) => prev + 1);
            }
        } catch (err: any) {
            toastr.error(getErrorMessage(err));
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (activeTab === 5) {
            fetchKartaDetails();
        }
    }, [activeTab]);

    return (
        <Box sx={{ p: 3 }}>
            <Grid container spacing={3}>
                <Grid item xs={6}>
                    <Typography>Pan Card Preview:</Typography>
                    <Box
                        sx={{
                            height: 250,
                            border: "1px solid #ccc",
                            borderRadius: 2,
                            overflow: "hidden",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        {panPreview ? (
                            <img
                                src={panPreview}
                                alt="PAN"
                                style={{ width: "100%", height: "100%" }}
                            />
                        ) : (
                            "No Preview"
                        )}
                    </Box>
                </Grid>

                <Grid item xs={6}>
                    <Typography>Deed Declaration Preview:</Typography>
                    <Box
                        sx={{
                            height: 250,
                            border: "1px solid #ccc",
                            borderRadius: 2,
                            overflow: "hidden"
                        }}
                    >
                        {deedPreview ? (
                            <iframe
                                src={deedPreview}
                                width="100%"
                                height="100%"
                                title="PDF"
                            />
                        ) : (
                            "No Preview"
                        )}
                    </Box>
                </Grid>

                <Grid item xs={6}>
                    <Typography>Pan Card Of Karta</Typography>
                    <input type="file" onChange={handlePanUpload} />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label="Pan Password"
                        name="huf_pan_card_plain_text_password"
                        value={form.huf_pan_card_plain_text_password}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={6}>
                    <Typography>Deed Of Declaration</Typography>
                    <input type="file" onChange={handleDeedUpload} />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label="Deed Password"
                        name="huf_deed_of_declaration_plain_text_password"
                        value={
                            form.huf_deed_of_declaration_plain_text_password
                        }
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label="Date Of Incorporation"
                        type="date"
                        name="date_of_incorporation"
                        value={form.date_of_incorporation}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label="Full Name Of Karta"
                        name="name_of_karta"
                        value={form.name_of_karta}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label="Occupation"
                        name="occupation"
                        value={form.occupation}
                        onChange={handleChange}
                    />
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        fullWidth
                        label="Karta Date Of Birth"
                        type="date"
                        name="karta_date_of_birth"
                        value={form.karta_date_of_birth}
                        onChange={handleChange}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>

                <Grid item xs={12} textAlign="center">
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={loading}
                        sx={{
                            backgroundColor: "#262349",
                            color: "#ffffff",
                            "&:hover": {
                                backgroundColor: "#1d1a3a",
                                color: "#ffffff"
                            }
                        }}
                    >
                        {loading ? "Uploading..." : "UPDATE KARTA DETAILS"}
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};